import { Route } from 'vue-router';
import Account from '@/services/Account/AccountService';

export async function handleRedirect(to: Route, from: Route, next: Function): Promise<void> {
  if (!to.query.lista || typeof to.query.lista !== 'string') {
    next(from);
    return;
  }

  const listaValue = to.query.lista;
  const accountService = new Account();

  try {
    next();
    const resultRedirect = await accountService.getRedirectPath(listaValue);
    window.location.href = resultRedirect.redirectPath;
  } catch (error) {
    next(from);
  }
}
